import { render, staticRenderFns } from "./game-fps-list.vue?vue&type=template&id=4913fd06&scoped=true&"
import script from "./game-fps-list.vue?vue&type=script&lang=js&"
export * from "./game-fps-list.vue?vue&type=script&lang=js&"
import style0 from "./game-fps-list.vue?vue&type=style&index=0&id=4913fd06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4913fd06",
  null
  
)

export default component.exports